import { rankWith, and, isControl } from "@jsonforms/core";

// Create a more specific tester that only targets when component="catalogSelect" is specified
export const catalogSelectorTester = rankWith(
  1000, // Very high priority
  and(
    isControl, // Make sure it's a Control element in uiSchema
    (uischema) => uischema.component === "catalogSelect" // Only match when component is specifically set
  )
);
